import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Timer } from 'lucide-react';
export function Offer() {
  // Simple countdown timer logic (24 hours from load)
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="oferta" className="pt-12 md:pt-20 pb-28 md:pb-20 bg-white scroll-mt-10" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-129">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4" data-id="element-130">
            Empezá hoy a recuperar la calma en casa
          </h2>
        </div>

        {/* Urgency Strip */}
        <div className="hidden md:block max-w-4xl mx-auto mb-8" data-id="element-131">
          <div className="bg-red-50 border border-red-100 rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left" data-id="element-132">
            <div className="flex items-center gap-2 text-red-700 font-medium" data-id="element-133">
              <span aria-hidden="true" data-id="element-134">🔥</span>
              Última oportunidad — el precio promocional puede cambiar sin aviso
            </div>
            <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg shadow-sm font-mono text-red-600 font-bold border border-red-100" data-id="element-135">
              <Timer className="w-4 h-4" data-id="element-136" />
              {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
              {formatTime(timeLeft.seconds)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-8 max-w-5xl mx-auto items-center" data-id="element-137">
          {/* Option 1: Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-ocean-cream rounded-2xl md:rounded-3xl p-4 md:p-8 border border-gray-100 shadow-sm flex flex-col h-full" data-id="element-138">
            <h3 className="text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center" data-id="element-139">
              Kit Base
            </h3>

            <ul className="space-y-2 md:space-y-4 mb-4 md:mb-8 flex-1 text-sm md:text-base" data-id="element-140">
              {['Kit Calma Total', 'Acceso inmediato', 'Formato digital PDF'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-141">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-ocean-teal shrink-0 mt-0.5" data-id="element-142" />
                  <span className="text-gray-700" data-id="element-143">{item}</span>
                </li>)}
              <li className="hidden sm:flex items-start gap-3 opacity-40" data-id="element-144">
                <div className="w-5 h-5 shrink-0" data-id="element-145" />
                <span className="text-gray-500 line-through" data-id="element-146">
                  Bono 1: Kit Express de Crisis
                </span>
              </li>
              <li className="hidden sm:flex items-start gap-3 opacity-40" data-id="element-147">
                <div className="w-5 h-5 shrink-0" data-id="element-148" />
                <span className="text-gray-500 line-through" data-id="element-149">
                  Bono 2: Guiones Calmos
                </span>
              </li>
              <li className="hidden sm:flex items-start gap-3 opacity-40" data-id="element-150">
                <div className="w-5 h-5 shrink-0" data-id="element-151" />
                <span className="text-gray-500 line-through" data-id="element-152">
                  Bono 3: Rutina Anticaos
                </span>
              </li>
              <li className="hidden sm:flex items-start gap-3 opacity-40" data-id="element-153">
                <div className="w-5 h-5 shrink-0" data-id="element-154" />
                <span className="text-gray-500 line-through" data-id="element-155">
                  Regalo: Tablero Maestro
                </span>
              </li>
            </ul>

            <div className="text-center mb-4 md:mb-8" data-id="element-156">
              <div className="text-xs md:text-base text-gray-500 line-through mb-1" data-id="element-157">
                Valor normal: $16.500
              </div>
              <div className="text-2xl md:text-4xl font-bold text-gray-900" data-id="element-158">
                Hoy: $4.990
              </div>
            </div>

            <a href="https://www.tera-ventasonline.shop/cart/45099734859891:1" target="_blank" rel="noopener noreferrer" className="w-full py-3 px-3 md:py-4 md:px-6 bg-white border-2 border-ocean-teal text-ocean-teal hover:bg-ocean-teal-light rounded-xl font-bold text-sm md:text-lg transition-colors text-center block" data-id="element-159">
              QUIERO EL KIT BASE
            </a>
          </motion.div>

          {/* Option 2: Megapack */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-ocean-teal rounded-2xl md:rounded-3xl p-1 shadow-soft-lg relative transform md:-translate-y-4" data-id="element-160">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-ocean-gold text-white px-3 md:px-4 py-1 rounded-full text-[11px] md:text-sm font-bold uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-161">
              ⭐ Más elegido
            </div>

            <div className="bg-white rounded-[18px] md:rounded-[22px] p-4 md:p-8 h-full flex flex-col" data-id="element-162">
              <h3 className="text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center text-ocean-teal-dark mt-2 md:mt-0" data-id="element-163">
                KIT Completo
              </h3>

              <ul className="space-y-2 md:space-y-4 mb-4 md:mb-8 flex-1 text-sm md:text-base" data-id="element-164">
                {['📘 Kit Calma Total', '⏱️ Bono 1: Kit Express de Crisis', '💬 Bono 2: Guiones Calmos', '🌙 Bono 3: Rutina Anticaos', '🎁 Regalo especial: Tablero Maestro', '⚡ Acceso inmediato', '📄 Formato digital PDF'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-165">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-ocean-gold-dark shrink-0 mt-0.5" data-id="element-166" />
                    <span className="text-gray-900 font-medium" data-id="element-167">{item}</span>
                  </li>)}
              </ul>

              <div className="text-center mb-4 md:mb-8" data-id="element-168">
                <div className="text-xs md:text-base text-gray-500 line-through mb-1" data-id="element-169">
                  Valor normal: $24.700
                </div>
                <div className="text-2xl md:text-5xl font-bold text-ocean-teal-dark" data-id="element-170">
                  Hoy: $7.490
                </div>
              </div>

              <motion.a href="https://www.tera-ventasonline.shop/cart/45099755602035:1" target="_blank" rel="noopener noreferrer" animate={{
              scale: [1, 1.04, 1]
            }} transition={{
              repeat: Infinity,
              duration: 1.8,
              ease: 'easeInOut'
            }} className="w-full py-3 px-3 md:py-4 md:px-6 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-sm md:text-lg transition-colors shadow-lg text-center block" data-id="element-171">
                QUIERO EL KIT CALMA COMPLETO
              </motion.a>
            </div>
          </motion.div>
        </div>

        <div className="text-center mt-8 text-sm text-gray-500" data-id="element-172">
          Oferta de lanzamiento por tiempo limitado
        </div>
      </div>
    </section>;
}